import {
    ArtifactFrame,
    ArtifactLifecycleStatusBadge,
} from '@apps/web/routes/_app/admin/agent/artifacts/frame';
import {
    type AdminArtifactRendererProps,
    toRecord,
} from '@apps/web/routes/_app/admin/agent/artifacts/shared';
import { formatPayloadBytes } from '@apps/web/routes/_app/admin/agent/payload_viewer_shared';

const ALLOWED_IMAGE_MIME_TYPES = new Set([
    'image/gif',
    'image/jpeg',
    'image/png',
    'image/webp',
]);

export function UploadedImageArtifact({
    artifact,
}: AdminArtifactRendererProps) {
    const payload = toRecord(artifact.payload);
    const mimeType =
        typeof payload['mime_type'] === 'string' ? payload['mime_type'] : null;
    const base64Data =
        typeof payload['base64_data'] === 'string'
            ? payload['base64_data']
            : null;
    const width =
        typeof payload['width'] === 'number' ? payload['width'] : null;
    const height =
        typeof payload['height'] === 'number' ? payload['height'] : null;
    const sizeBytes =
        typeof payload['size_bytes'] === 'number'
            ? payload['size_bytes']
            : null;
    const canRenderImage =
        mimeType !== null &&
        ALLOWED_IMAGE_MIME_TYPES.has(mimeType) &&
        base64Data !== null;
    const dimensionLabel =
        width !== null && height !== null ? `${width}×${height}` : null;
    return (
        <ArtifactFrame
            artifact={artifact}
            status={
                <ArtifactLifecycleStatusBadge
                    lifecycleStatus={artifact.lifecycle_status}
                />
            }
        >
            {canRenderImage ? (
                <img
                    src={`data:${mimeType};base64,${base64Data}`}
                    alt={artifact.title}
                    className="border-border/60 h-auto w-auto max-w-full rounded-md border"
                />
            ) : (
                <p className="text-muted-foreground text-xs">
                    Image content is unavailable (it may have expired).
                </p>
            )}
            <p className="text-muted-foreground text-[11px]">
                {[
                    mimeType,
                    dimensionLabel,
                    sizeBytes !== null ? formatPayloadBytes(sizeBytes) : null,
                ]
                    .filter(Boolean)
                    .join(' · ')}
            </p>
        </ArtifactFrame>
    );
}
